import { useGetUserByIdQuery, useGetUserStatisticsQuery } from '../userApi';

export const useUserById = (params = {}) => {
  return useGetUserByIdQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      user: data,
      isLoading,
      isError,
      error,
    }),
    skip: !params.id,
  });
};

export const useUserStatistics = (params = {}) => {
  return useGetUserStatisticsQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      statistics: data || [],
      isLoading,
      isError,
      error,
    }),
    skip: !params.userId,
  });
};
